import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/rootReducer";
import { Flashbar, FlashbarProps } from "@amzn/awsui-components-react/polaris";
import React from "react";
import {
  CACHEABLE_NOTIFICATION_TTL_MS,
  removeCacheableNotification,
} from "./cacheableNotificationConnector";
import moment from "moment/moment";

export const CacheableNotification = () => {
  const dispatch = useDispatch();
  const { notificationItems } = useSelector(
    (state: RootState) => state.cacheableNotification
  );
  const currentTimeMs = moment.now();
  const flashBarItems: FlashbarProps.MessageDefinition[] = Object.entries(
    notificationItems
  )
    .filter(
      ([key]) => currentTimeMs - parseInt(key) < CACHEABLE_NOTIFICATION_TTL_MS
    )
    .map(([key, value]) => {
      return {
        ...value,
        id: key,
        onDismiss: () => dispatch(removeCacheableNotification(parseInt(key))),
      };
    });
  // Same guard as `Notification`: skip mounting the Flashbar when
  // there is nothing to show, so Cloudscape's react-transition-group
  // never has a chance to leave a removed `<li>` stuck in
  // `awsui_exiting`.
  if (flashBarItems.length === 0) {
    return null;
  }
  return <Flashbar items={flashBarItems} />;
};
